<!-- NAVBAR -->
<nav
  class="navbar navbar-expand-lg fixed-top navbar-custom"
  [class.scrolled]="isScrolled"
>
  <div class="container">

    <a
      class="navbar-brand"
      href="#inicio"
      aria-label="Home"
    ></a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#mobileMenu"
    >
      <i class="bi bi-list"></i>
    </button>

    <div class="collapse navbar-collapse d-none d-lg-flex">
      <ul class="navbar-nav ms-auto gap-4">

        <li class="nav-item">
          <a class="nav-link" href="#inicio">Home</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#servicios">Services</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#nosotros">About</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#proceso">Process</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#testimonials">Testimonials</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="#contacto">Contact</a>
        </li>

      </ul>
    </div>

  </div>
</nav>

<!-- MOBILE MENU -->
<div
  class="offcanvas offcanvas-end mobile-menu"
  tabindex="-1"
  id="mobileMenu"
>
  <div class="offcanvas-header">
    <h5 class="text-white">Menu</h5>

    <button
      type="button"
      class="btn-close btn-close-white"
      data-bs-dismiss="offcanvas"
    ></button>
  </div>

  <div class="offcanvas-body">
    <ul class="navbar-nav text-center">

      <li class="nav-item">
        <a class="nav-link" href="#inicio" data-bs-dismiss="offcanvas">
          Home
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="#servicios" data-bs-dismiss="offcanvas">
          Services
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="#nosotros" data-bs-dismiss="offcanvas">
          About
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="#proceso" data-bs-dismiss="offcanvas">
          Process
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="#testimonials" data-bs-dismiss="offcanvas">
          Testimonials
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" href="#contacto" data-bs-dismiss="offcanvas">
          Contact
        </a>
      </li>

    </ul>
  </div>
</div>

<!-- HERO -->
<section id="inicio" class="hero">
  <div class="container">
    <div class="row align-items-center g-5">

      <div class="col-lg-6">
        <h1>
          Retire the way you want.
          Keep your money in the family.
        </h1>

        <p>
          Health and life insurance. Estate planning. Retirement strategy.
        </p>

        <a href="#contacto" class="btn-main">
          Schedule a consultation
          <i class="bi bi-info-circle-fill"></i>
        </a>
      </div>

      <div class="col-lg-6 im"></div>

    </div>
  </div>
</section>

<!-- SERVICES -->
<section id="servicios" class="services">
  <div class="container">

    <div class="text-center mb-5">
      <span class="section-tag text-light">
        SERVICES
      </span>

      <h2 class="text-white">
        We can guide you to:
      </h2>
    </div>

    <div class="row g-4">

      <div class="col-md-6 col-lg-3">
        <div class="service-card">
          <i class="bi bi-briefcase-fill"></i>
          <p><b>Get family and business protection.</b><br>
            Get funds in case of an unexpected event.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="service-card">
          <i class="bi bi-calendar-check"></i>
          <p><b>Retire the way you want.</b><br>
            Accumulate capital or get income for life.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="service-card">
          <i class="bi bi-house-up-fill"></i>
          <p><b>Estate Planning.</b><br>
            Prepare the legal framework to transfer your wealth.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="service-card">
          <i class="bi bi-person-bounding-box"></i>
          <p><b>Leave a Legacy.</b><br>
            Build generational wealth.</p>
        </div>
      </div>

    </div>

  </div>
</section>

<!-- ABOUT -->
<section id="nosotros" class="section secabout">
  <div class="container">
    <div class="row align-items-center g-5">

      <div class="col-lg-6">
        <div
          id="aboutCarousel"
          class="carousel slide about-carousel"
          data-bs-ride="carousel"
          data-bs-interval="4500"
        >
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                src="/ABOUT.jpg"
                class="about-img d-block w-100"
                alt="Retirement planning"
              >
            </div>

            <div class="carousel-item">
              <img
                src="/ABOUT2.jpg"
                class="about-img d-block w-100"
                alt="Family protection planning"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">

        <h2>
          Transfer and reduce risks. Get funding when you most need it. Avoid probate.
        </h2>

        <p class="about-text">
          Most probably, you are a successful person, you have a family, a home, friends and
          properties. Maybe you have a business. You might want to assure the future of your
          family, transferring them your assets. Most probably, you have a dream plan for your
          retirement.
        </p>

        <p class="about-text">
          Life is also risk. Unexpected events can happen today or in the future. People do not
          know when they will pass away. Some live too long, some too short. People can get
          seriously ill, or require long term care. Most people retire. Some want to transfer wealth
          to the next generation, and pay less taxes. You can pay it out of pocket, or get funds
          when mostly need it.
        </p>

        <p class="about-text">
          One of the most tax efficient options to protect your family, assets and transfer wealth is
          insurance. Prepare the legal framework to avoid probate and reduce your taxes.
        </p>

      </div>

      <div class="col-lg-12">
        <div class="socialsabout">

          <a class="reqabout" href="#contact">Request information</a>

          <a class="san" href="https://www.linkedin.com/in/jorgecalaforra/">
            <i class="bi bi-linkedin"></i>
          </a>

          <a class="san" href="https://www.facebook.com/CalaforraGroup">
            <i class="bi bi-facebook"></i>
          </a>

          <a class="san" href="https://www.youtube.com/@Prosperit.living">
            <i class="bi bi-youtube"></i>
          </a>

          <a class="san" href="https://www.instagram.com/prosperiy.living/">
            <i class="bi bi-instagram"></i>
          </a>

          <a class="san" href="https://www.blogger.com/u/1/blog/post/edit/preview/247037656368727208/5966500728901442242">
            <i class="fa-brands fa-blogger-b"></i>
          </a>

        </div>
      </div>


    </div>
  </div>  
</section>

<!-- PROCESS -->
<section id="proceso" class="section process">
  <div class="container">

    <div class="text-center mb-5">
      <span class="section-tag">
        PROCESS
      </span>

      <h2>
        Our process
      </h2>
    </div>

    <div class="row g-4 text-center justify-content-center">

      <div class="col-md-4 col-lg-3">
        <div class="process-box h-100">
          <div class="number">1</div>
          <h5>
            Define what do you want and what is the most important to you.
            Assess the cost of doing nothing.
          </h5>
        </div>
      </div>

      <div class="col-md-4 col-lg-3">
        <div class="process-box h-100">
          <div class="number">2</div>
          <h5>
            Make an appointment. If our cooperation makes sense, we prepare a road map
            based on your wishes, budget and best interest.
          </h5>
        </div>
      </div>

      <div class="col-md-4 col-lg-3">
        <div class="process-box active h-100">
          <div class="number">3</div>
          <h5>
            Enjoy the rest of your life. Make your sunset beautiful. Leave a legacy.
          </h5>
        </div>
      </div>

    </div>

  </div>
</section>

<!-- TESTIMONIALS -->
<section id="testimonials" class="section testimonials">
  <div class="container">

    <div class="text-center mb-5">
      <span class="section-tag">
        TESTIMONIALS
      </span>

      <h2>
        What people say about us
      </h2>

      <p class="testimonials-subtitle">
        Real experiences from people who decided to protect their family, retirement and legacy.
      </p>
    </div>

    <div class="row g-4">

      @for (testimonial of paginatedTestimonials; track testimonial.id) {

        <div class="col-md-6 col-lg-4">
          <div class="testimonial-card">

            <div class="testimonial-stars">
              @for (star of getStars(testimonial.rating); track star) {
                <i class="bi bi-star-fill"></i>
              }
            </div>

            <p class="testimonial-message">
              “{{ testimonial.message }}”
            </p>

            <div class="testimonial-client">
              <div class="testimonial-avatar">
                {{ testimonial.name.charAt(0) }}
              </div>

              <div>
                <h5>
                  {{ testimonial.name }}
                </h5>

                <span>
                  {{ testimonial.location }}
                </span>
              </div>
            </div>

          </div>
        </div>

      }

    </div>

    @if (totalTestimonialPages > 1) {
      <div class="testimonial-pagination">
        <button
          type="button"
          class="pagination-arrow"
          (click)="goToPreviousTestimonialPage()"
          [disabled]="currentTestimonialPage === 1"
        >
          <i class="bi bi-arrow-left"></i>
        </button>

        @for (page of testimonialPageNumbers; track page) {
          <button
            type="button"
            class="pagination-page"
            [class.active]="page === currentTestimonialPage"
            (click)="goToTestimonialPage(page)"
          >
            {{ page }}
          </button>
        }

        <button
          type="button"
          class="pagination-arrow"
          (click)="goToNextTestimonialPage()"
          [disabled]="currentTestimonialPage === totalTestimonialPages"
        >
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    }

    <a href="/Testimonials" class="dartestimonio">
      Give my testimony
    </a>

  </div>
</section>

<!-- CONTACT -->
<section id="contacto" class="contact">
  <div class="container">

    <div class="row justify-content-center">
      <div class="col-lg-6">

        <div class="contact-box">

          <h3>
            Request information
          </h3>

          <form
            #contactForm="ngForm"
            (ngSubmit)="sendEmail(contactForm)"
          >

            <input
              type="text"
              class="form-control"
              placeholder="Full name"
              [(ngModel)]="formData.name"
              name="name"
              required
            >

            <input
              type="email"
              class="form-control"
              placeholder="Mail"
              [(ngModel)]="formData.email"
              name="email"
              required
            >

            <textarea
              rows="5"
              class="form-control"
              placeholder="Message"
              [(ngModel)]="formData.message"
              name="message"
              required
            ></textarea>

            <button
              type="submit"
              class="btn-main w-100"
              [disabled]="isSending"
            >

              @if (!isSending) {
                <span>
                  Send inquiry
                </span>
              } @else {
                <span class="d-flex justify-content-center align-items-center gap-2">
                  <span class="spinner-border spinner-border-sm"></span>
                  Sending...
                </span>
              }

            </button>

          </form>

        </div>

      </div>
    </div>

  </div>
</section>

<!-- FOOTER -->
<footer class="footer">
  <div class="container">

    <div class="row align-items-center">

      <div class="col-md-6">
        <h4>
          Calaforra Group
        </h4>

        <p>
          Retirement planning, family protection, insurance and wealth transfer solutions.
        </p>
      </div>

      <div class="col-md-6 text-md-end">

        <div class="socials">

          <a href="https://www.linkedin.com/in/jorgecalaforra/">
            <i class="bi bi-linkedin"></i>
          </a>

          <a href="https://www.facebook.com/CalaforraGroup">
            <i class="bi bi-facebook"></i>
          </a>

          <a href="https://www.youtube.com/@Prosperit.living">
            <i class="bi bi-youtube"></i>
          </a>

          <a href="https://www.instagram.com/prosperiy.living/">
            <i class="bi bi-instagram"></i>
          </a>

          <a href="https://www.blogger.com/u/1/blog/post/edit/preview/247037656368727208/5966500728901442242">
            <i class="fa-brands fa-blogger-b"></i>
          </a>

        </div>

      </div>

    </div>

    <div class="row mt-4">
      <div class="col-12">

        <div class="disclaimer">
          <p>
            <strong>Disclaimer.</strong> <br>
            I’m licensed and insured to offer health, life, and property and casualty insurance.
            Coverage and pricing of insurance companies is subject to eligibility and underwriting requirements.
            You must be eligible for some programs to get benefits.
            Not all products are available in all areas.
            I'm not a tax advisor, but I will work with yours to find a tax efficient process.
            My values are integrity, respect for privacy and respect for your time.
          </p>
        </div>

      </div>
    </div>

  </div>
</footer>

<button
  id="topBtn"
  [class.show]="showTopButton"
  (click)="scrollToTop()"
>
  <i class="bi bi-arrow-up"></i>
</button>
